import {useNavigate} from 'react-router-dom'
import {NewItem} from './NewsItem'
import st from './News.module.scss'
import arrow from 'assets/images/svg/arrow-icon.svg'
import newsBg from 'assets/images/news_bg.png'
import {useAppContext} from 'Context'
import {Spinner} from 'components/Spinner/Spinner'
import {useNews} from 'helpers';

export const News = ()=> {
    const navigate = useNavigate()
    const { region } = useAppContext()
    const { data, isLoading  } = useNews(region?.id, 6)
    const cn = st.news+' '+st.news_first + ' ' +(!data ? st.news_pre_load : '' )

    const toGo = () => {
        window.scroll({ top: 0, behavior: 'smooth' })
        navigate('/news')
    }

    const cnLoad = st.list+' '+(isLoading ? st.list_load : '')

    return !!data?.length ? (
        <section className={cn}>
            <div className={st.bg}>
                <picture>
                    <img src={newsBg} alt="" width={100} height={100} />
                </picture>
            </div>

            <div className="wrapper">
                <div className={st.head}>
                    <h2 className={st.title}>новости</h2>
                    <button className={st.link} onClick={toGo}>
                        <span>Смотреть всё</span>
                        <img src={arrow} alt="" width={24} height={24} />
                    </button>
                </div>

                <div className={cnLoad}>
                    {isLoading && <div className={st.loader}><Spinner cn={st.spin} /></div>}

                    {data && data?.slice(0, 6).map(news => <NewItem data={news} key={news.id} />)}
                </div>
            </div>
        </section>
    ) : null
}
